import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { RiskFactorComponentView } from '../RiskFactorComponentView';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';


/**
 * リスクファクターモード
 */
export class RiskFactorMode extends WprBaseViewModeInfo<RiskFactorComponentView> {
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Dest: WprControlInfo 			= null; 	// 主な旅行先
	@WprDI_Control
	private m_PeriodFrom: WprControlInfo 	= null; 	// 旅行期間(始期)
	@WprDI_Control
	private m_PeriodTo: WprControlInfo 		= null; 	// 旅行期間(終期)
	@WprDI_Control
	private m_Person: WprControlInfo 		= null; 	// 旅行する人数
	@WprDI_Control
	private m_Purpose: WprControlInfo 		= null; 	// 旅行の目的
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('riskFactorMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('true');
		list.push('false');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('pittari', { display: [{ mode: 'false', value: false}, { mode: 'other', value: true},],});
		this.addControl('next', { enabled: [{ mode: 'false', value: false}, { mode: 'other', value: true},],});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (this.getGlobalMode('product') === 'DTP'){
			if(this.view.isInput('DTP') === false)
				return 'false';
		}
		if (this.getGlobalMode('product') === 'OTA'){
			if(this.view.isInput() === false)
				return 'false';
		}
		return 'true';
	}

	private checkPeriodIsEmpty(): boolean {
		if (this.m_PeriodFrom.value && this.m_PeriodTo.value)
			return true;
		return false;
	}
// --------------------------------------------------------------------------
}